import {
    HydratedComparisonField,
    HydratedComparisonView,
    HydratedCurriculumType,
} from 'src/Common/types/AppConfigTypes';
import { ComparisonItem } from './ComparisonView';

export const getLinkItemValue = (
    comparisonField: HydratedComparisonField,
    comparisonItem: ComparisonItem,
    activeCurriculumType: HydratedCurriculumType,
) => {
    const linkKey = findLinkKey(comparisonField, activeCurriculumType);

    //eslint-disable-next-line
    const linkedItem = comparisonItem[linkKey] as any;

    return (linkedItem && linkedItem[comparisonField.field.slug]) || '';
};

export const getNameValue = (
    comparisonView: HydratedComparisonView,
    comparisonItem: ComparisonItem,
) => {
    return comparisonItem[comparisonView.name.field.slug];
};

export const findLinkKey = (
    linkComparisonField: HydratedComparisonField,
    activeCurriculumType: HydratedCurriculumType,
) => {
    // this is currently the best way to find the value - could there in some
    // cases be more data needed to be added to the config?
    const linkContentTypeUuid = linkComparisonField.contentType.uuid;

    const fieldsLinkingToThisContentType = activeCurriculumType.contentType.fields.find(
        field => field.controls.linkUuid === linkContentTypeUuid,
    );

    return (
        (fieldsLinkingToThisContentType &&
            fieldsLinkingToThisContentType.slug) ||
        ''
    );
};

export const getIsFieldCurrency = (
    comparisonField: HydratedComparisonField,
): boolean => {
    return (
        comparisonField.field.controls &&
        comparisonField.field.controls.fieldType === 'Currency'
    );
};

export const getComparisonItemFieldValue = (
    comparisonField: HydratedComparisonField,
    comparisonItem: ComparisonItem,
    activeCurriculumType: HydratedCurriculumType,
) => {
    const potentialValue = comparisonItem[comparisonField.field.slug];

    const value =
        potentialValue === undefined // this means it's probably a link value
            ? getLinkItemValue(
                  comparisonField,
                  comparisonItem,
                  activeCurriculumType,
              )
            : potentialValue;

    const isCurrencyField = getIsFieldCurrency(comparisonField);

    return !!value && isCurrencyField ? `$${value}` : value;
};
